import React, { useState } from 'react';
import { Search as ControlledSearchInput } from '@blueprintnyc/bpnyc-common-admin';

const Search = props => {
	const { defaultValue } = props;

	const [value, setValue] = useState(defaultValue);

	return <ControlledSearchInput value={value} onChange={setValue} {...props} />;
};

export default Search;
